module.exports = [
    'https://fonts.googleapis.com/css2?family=Roboto&display=swap',
    'https://fonts.googleapis.com/css2?family=Open+Sans&display=swap',
    'https://fonts.googleapis.com/css2?family=Dancing+Script&display=swap',
    'https://fonts.googleapis.com/css2?family=Lato&display=swap',
    'https://fonts.googleapis.com/css2?family=Noto+Sans+JP&display=swap',
    'https://fonts.googleapis.com/css2?family=Montserrat&display=swap',
    'https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap',
    'https://fonts.googleapis.com/css2?family=Oswald&display=swap',
    'https://fonts.googleapis.com/css2?family=Raleway&display=swap',
    'https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap',
    'https://fonts.googleapis.com/css2?family=Poppins&display=swap',
    'https://fonts.googleapis.com/css2?family=Noto+Sans&display=swap',
    'https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap',
    'https://fonts.googleapis.com/css2?family=Merriweather&display=swap',
    'https://fonts.googleapis.com/css2?family=PT+Sans&display=swap',
    'https://fonts.googleapis.com/css2?family=Ubuntu&display=swap',
    'https://fonts.googleapis.com/css2?family=Playfair+Display&display=swap',
    'https://fonts.googleapis.com/css2?family=Muli&display=swap',
    'https://fonts.googleapis.com/css2?family=Open+Sans+Condensed:wght@300&display=swap',
    'https://fonts.googleapis.com/css2?family=Mukta&display=swap',
    'https://fonts.googleapis.com/css2?family=PT+Serif&display=swap',
    'https://fonts.googleapis.com/css2?family=Lora&display=swap',
    'https://fonts.googleapis.com/css2?family=Nunito&display=swap',
    'https://fonts.googleapis.com/css2?family=Work+Sans&display=swap',
    'https://fonts.googleapis.com/css2?family=Rubik&display=swap',
    'https://fonts.googleapis.com/css2?family=Fira+Sans&display=swap',
    'https://fonts.googleapis.com/css2?family=Noto+Sans+KR&display=swap',
    'https://fonts.googleapis.com/css2?family=Noto+Serif&display=swap',
    'https://fonts.googleapis.com/css2?family=Titillium+Web&display=swap',
    'https://fonts.googleapis.com/css2?family=Noto+Sans+TC&display=swap',
    'https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap',
    'https://fonts.googleapis.com/css2?family=Quicksand&display=swap',
    'https://fonts.googleapis.com/css2?family=Hind+Siliguri&display=swap',
    'https://fonts.googleapis.com/css2?family=Nunito+Sans&display=swap',
    'https://fonts.googleapis.com/css2?family=PT+Sans+Narrow&display=swap',
    'https://fonts.googleapis.com/css2?family=Heebo&display=swap',
    'https://fonts.googleapis.com/css2?family=Inconsolata&display=swap',
    'https://fonts.googleapis.com/css2?family=Barlow&display=swap',
    'https://fonts.googleapis.com/css2?family=Arimo&display=swap',
    'https://fonts.googleapis.com/css2?family=Dosis&display=swap',
    'https://fonts.googleapis.com/css2?family=Oxygen&display=swap',
    'https://fonts.googleapis.com/css2?family=Anton&display=swap',
    'https://fonts.googleapis.com/css2?family=Yanone+Kaffeesatz&display=swap',
    'https://fonts.googleapis.com/css2?family=Karla&display=swap',
    'https://fonts.googleapis.com/css2?family=Crimson+Text&display=swap',
    'https://fonts.googleapis.com/css2?family=Cabin&display=swap',
    'https://fonts.googleapis.com/css2?family=Bitter&display=swap',
    'https://fonts.googleapis.com/css2?family=Josefin+Sans&display=swap',
    'https://fonts.googleapis.com/css2?family=Hind&display=swap',
    'https://fonts.googleapis.com/css2?family=Teko&display=swap',
    'https://fonts.googleapis.com/css2?family=Libre+Franklin&display=swap',
]
